/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FindUnitsRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {FindUnitsResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const findUnits = (request: FindUnitsRequest, options?: CashRequestOptions) => post<FindUnitsRequest, FindUnitsResponse>("/2.0/cash/find-units", request, {...options, rejectOnError: true })